module.exports = __webpack_public_path__ + "static/media/Logo_Project_2.b36f86c1.png";